import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { JobsTable } from "./-pages/jobsTable";
import { queryClient, trpc } from "~/utils/trpc";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { useJobLabels } from "~/hooks/useJobLabels";

const tableName = "recruitment_jobs";
export const Route = createFileRoute("/_dashboard/$datasetSlug/data/jobs/")({
  component: RouteComponent,
  loader: async () => {
    const tablePrefs = await queryClient.fetchQuery(trpc.users.getTablePreferences.queryOptions({ tableName }));

    return {
      initialDataFilters: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.filters
        : tablePrefs.originalFilters,
      baseDataFilters: tablePrefs.originalFilters,

      initialColumnsDisplay: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.columnsDisplay
        : tablePrefs.defaultColumnsDisplay,
      baseColumnsDisplay: tablePrefs.defaultColumnsDisplay,

      initialColumnsOrder: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.columnsOrder
        : tablePrefs.defaultColumnsOrder,
      baseColumnsOrder: tablePrefs.defaultColumnsOrder,

      activeSort: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.sort
        : [],

      activePreferenceId: tablePrefs.activePreferenceId,
    };
  },
});

function RouteComponent() {
  const {
    initialDataFilters,
    baseDataFilters,
    initialColumnsOrder,
    initialColumnsDisplay,
    baseColumnsOrder,
    baseColumnsDisplay,
    activeSort,
    activePreferenceId,
  } = Route.useLoaderData();
  const { datasetSlug } = Route.useParams();
  const { data: views } = useQuery(trpc.entityViews.getViews.queryOptions({ entityType: "recruitment_jobs" }));
  const { plural } = useJobLabels();
  useBreadCrumbs([{ title: plural, link: `/${datasetSlug}/data/jobs` }]);
  return (
    <JobsTable
      initialDataFilters={initialDataFilters}
      baseDataFilters={baseDataFilters}
      //
      initialColumnsDisplay={initialColumnsDisplay}
      baseColumnsDisplay={baseColumnsDisplay}
      //
      initialColumnsOrder={initialColumnsOrder}
      baseColumnsOrder={baseColumnsOrder}
      //
      views={views ?? []}
      activeSort={activeSort}
      activePreferenceId={activePreferenceId}
    />
  );
}
